import { render, staticRenderFns } from "./TransactionBulks.vue?vue&type=template&id=580d5303&"
import script from "./TransactionBulks.vue?vue&type=script&lang=js&"
export * from "./TransactionBulks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports